import { log } from '@economic/react-app';

import eventApiClient from '~/app/shared/util/api/eventApiClient';

/**
 * Will send an event to mailbox in channel named as:
 *
 * - `economic.events.${areaName}.{action}`
 *
 * @example
 *
 * ```ts
 * // In e-conomic-mixpanel
 * mailbox.pull('economic.events.journal.view-journal', ...);\
 *
 * // In client
 * track('journal', 'view-journal')
 * ```
 */

export default function track(areaName: string, action: string, trackingData?: object): void {
    eventApiClient
        .post('/EmitEvent', {
            action,
            areaName,
            data: trackingData || {},
        })
        .catch(error => {
            if (error?.response) {
                log.error(error);
            }
        });
}
